<template>
    <el-container style="height: 100%">
        <el-header style="height: 30px">
            <van-nav-bar title="顾客咨询信息" left-text="返回" left-arrow @click-left="historyBack"/>
        </el-header>
        <el-main style="height: 100%">
            <el-table height="calc(100% - 0rem)" border :data="websiteData" highlight-current-row :loadmore="loadmore">
                <el-table-column label="顾客姓名"  align="center" prop="custname"></el-table-column>
                <el-table-column label="手机号码"  align="center" prop="phone"></el-table-column>
                <el-table-column label="品牌名称"  align="center" prop="storename"></el-table-column>
                <el-table-column label="所在区域"  align="center" prop="address"></el-table-column>
                <el-table-column label="品牌类型"  align="center" prop="storetype"></el-table-column>
            </el-table>
        </el-main>
    </el-container>
</template>
<script>
export default {
    data() {
        return {
            websiteData: [],
            curpage: 1,
            isFinite: false,
        }
    },
    created() {
        this.getInteboWebSiteByPage();
    },
    methods: {
        getInteboWebSiteByPage() {
            this.$post("inteboStore/getInteboWebSiteByPage", {curpage: this.curpage, pagesize: 50}).then(res => {
                if (res.sucess) {
                    let obj = res.object;
                    if (obj != null && obj.length > 0) {
                        for (let val of obj) {
                            this.websiteData.push(val);
                        }
                    } else {
                        this.isFinite = true;
                    }
                }
            });
        },
        loadmore() {
            if (this.isFinite == false) {
                this.curpage++;
                this.getInteboWebSiteByPage();
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/page/intebo/intebowebsite/seachwebsite.vue